import { useEffect, useRef, useState } from "react";
import styles from "./InfoTooltip.module.scss";

interface InfoTooltipProps {
  text: string;
  /** Align the bubble to the right edge of the icon (default) or left. */
  align?: "left" | "right";
}

function InfoCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="10" cy="10" r="8.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10 13.333V10M10 6.667h.008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function InfoTooltip({ text, align = "right" }: InfoTooltipProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [open]);

  return (
    <span className={styles.wrap} ref={ref}>
      <button
        type="button"
        className={styles.trigger}
        aria-label="Подробнее"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <InfoCircleIcon className={styles.icon} />
      </button>
      <span
        role="tooltip"
        className={`${styles.bubble} ${
          align === "left" ? styles.alignLeft : styles.alignRight
        } ${open ? styles.bubbleOpen : ""}`}
      >
        {text}
      </span>
    </span>
  );
}
